import { useState } from 'react';
import { Activation } from './activation/Activation';
import { Player } from './player/Player';
import { getDeviceToken, clearDeviceToken } from './storage';

export function App() {
  const [token, setToken] = useState<string | null>(() => getDeviceToken());

  if (!token) {
    return <Activation onPaired={(t) => setToken(t)} />;
  }

  return (
    <Player
      token={token}
      onUnauthorized={() => {
        clearDeviceToken();
        setToken(null);
      }}
    />
  );
}
